import React from 'react'

/** @param {import('./Badges').BadgesProps} props */
export default function Badges(props) {
    const {discount, novelty, quality, popularity, certified} = props.badges

    return (
        <>
            <If condition={discount !== 0}>
                <div className="b-badge">
                    <div className="b-badge__icon b-badge__icon_discount_small" />
                </div>
            </If>
            <If condition={novelty}>
                <div className="b-badge">
                    <div className="b-badge__icon b-badge__icon_new" />
                </div>
            </If>
            <If condition={popularity !== 0}>
                <div className="b-badge">
                    <div className="b-badge__icon b-badge__icon_popularity" />
                </div>
            </If>
            <If condition={quality}>
                <div className="b-badge">
                    <div className="b-badge__icon b-badge__icon_quality" />
                </div>
            </If>
            <If condition={certified}>
                <div className="b-badge">
                    <div className="b-badge__icon b-badge__icon_certified_mask" />
                </div>
            </If>
        </>
    )
}
